import React from 'react';
import { useParams, Link } from 'react-router-dom';

export default function RoomDetailPage() {
  const { id } = useParams();

  return (
    <div className="container mx-auto px-4 py-20">
      <Link to="/rooms" className="text-blue-600 hover:text-blue-800 mb-6 inline-block">← Terug naar kamers</Link>
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg overflow-hidden">
        <img src={`https://picsum.photos/seed/roomdetail${id}/800/400`} alt="Room" className="w-full h-80 object-cover" />
        <div className="p-8">
          <h1 className="text-4xl font-bold mb-4">Kamer Details</h1>
          <p className="text-gray-600 mb-6">Meer informatie over deze kamer volgt binnenkort.</p>
          <button className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-3 rounded-full font-bold hover:shadow-lg transition">
            Reageren
          </button>
        </div>
      </div>
    </div>
  );
}
